/* 會員相關接口 */

import request from '@/utils/http/request'



/* List */
export async function fetchAll({ barCode, itemName, itemCode, sDate, eDate, exp, page, pageSize }) {
    return await request.post('/product', {
        barCode, itemName, itemCode, sDate, eDate, exp, page, pageSize
    }, {
        noAuth: false
    });
}

export async function pageExport({ barCode, itemName, itemCode, sDate, eDate, exp }) {
    return await request.post('/product', { barCode, itemName, itemCode, sDate, eDate, exp },
        {
            responseType: 'blob',
            noAuth: false
        }

    );
}


export async function store({ url }) {
    return await request.post('/product/store', {
        url
    }, {
        noAuth: false
    });
}